export const products = [
  {
    img1: "./img/product-1.jpg",
    imgDesk1: "./img/product-1-desktop.jpg",
    imgDesk2: "./img/product-1-desktop@2x.jpg"
  },
  {
    img1: "./img/product-2.jpg",
    imgDesk1: "./img/product-2-desktop.jpg",
    imgDesk2: "./img/product-2-desktop@2x.jpg"
  },
  {
    img1: "./img/product-3.jpg",
    imgDesk1: "./img/product-3-desktop.jpg",
    imgDesk2: "./img/product-3-desktop@2x.jpg"
  },
  {
    img1: "./img/product-4.jpg",
    imgDesk1: "./img/product-4-desktop.jpg",
    imgDesk2: "./img/product-4-desktop@2x.jpg"
  },
  {
    img1: "./img/product-5.jpg",
    imgDesk1: "./img/product-5-desktop.jpg",
    imgDesk2: "./img/product-5-desktop@2x.jpg"
  },
  {
    img1: "./img/product-6.jpg",
    imgDesk1: "./img/product-6-desktop.jpg",
    imgDesk2: "./img/product-6-desktop@2x.jpg"
  },
  {
    img1: "./img/product-7.jpg",
    imgDesk1: "./img/product-7-desktop.jpg",
    imgDesk2: "./img/product-7-desktop@2x.jpg"
  },
  {
    img1: "./img/product-8.jpg",
    imgDesk1: "./img/product-8-desktop.jpg",
    imgDesk2: "./img/product-8-desktop@2x.jpg"
  },
  {
    img1: "./img/product-9.jpg",
    imgDesk1: "./img/product-9-desktop.jpg",
    imgDesk2: "./img/product-9-desktop@2x.jpg"
  },
  {
    img1: "./img/product-10.jpg",
    imgDesk1: "./img/product-10-desktop.jpg",
    imgDesk2: "./img/product-10-desktop@2x.jpg"
  }
];